// PRIPREMA / KONTROLIŠE / ODOBRAVA liste poslovnih procesa organizacione jedinice
export const SIGNATURE_ROLES = ["prepared_by", "controlled_by", "approved_by"];
export const SIGNATURE_DATES = ["prepared_at", "controlled_at", "approved_at"];

export const pickSignatures = (unit) => {
  const signatures = {};
  SIGNATURE_ROLES.forEach((role) => {
    signatures[`${role}_employee_id`] = unit?.[`${role}_employee_id`] ?? null;
    signatures[role] = unit?.[role] ?? null;
  });
  SIGNATURE_DATES.forEach((field) => {
    signatures[field] = unit?.[field] ?? null;
  });
  return signatures;
};

// Pun payload: backend update uvek upisuje jedinicu, nivo i rukovodioca
export const buildSignaturesPayload = (unit, draft) => {
  const payload = {
    id: unit.id,
    organization_unit_id: unit.organization_unit_id,
    level: unit.level,
    manager_employee_id: unit.manager_employee_id ?? null,
  };
  SIGNATURE_ROLES.forEach((role) => {
    payload[`${role}_employee_id`] = draft?.[`${role}_employee_id`] ?? null;
  });
  SIGNATURE_DATES.forEach((field) => {
    payload[field] = draft?.[field] || null;
  });
  return payload;
};

export const formatSignatureEmployee = (employee) => {
  if (!employee) return "";
  const name = `${employee.first_name || ""} ${employee.last_name || ""}`.trim();
  return employee.designation_name ? `${name} - ${employee.designation_name}` : name;
};

export const formatSignatureDate = (value) => {
  if (!value) return "";
  const [year, month, day] = String(value).slice(0, 10).split("-");
  return year && month && day ? `${day}.${month}.${year}.` : "";
};
